<template>
	<div style="width: 1200px;margin: 70px auto;">
		<bar></bar>
		<div style="width: 1200px;height: 30px; margin-top: 20px;;bconfirm-bottom: 1px solid #000000;"><span style="font-size: 14px;float: left">首页/我的订单</span></div>
		<div style="width: 1200px;margin:0 auto;">
			<div style="width: 1200px;height: 40px;margin-top: 50px;">
				<span style="float: left;margin: 8px 15px 0 0;">订单日期</span>
				<div class="block" style="display: inline-block;float: left;" id="block-color">
					<el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="value1" type="date" placeholder="选择日期"></el-date-picker>
				</div>
				<el-button @click="queryData" size="medium" id="vehicle-buttont" style="float:right;margin-top: 4px;">查询</el-button>
			</div>
		</div>
		<br>
		<el-table :header-cell-style="{background:'#e5e5e5',color:'#2c3e50'}" :data="list" v-loading.body="listLoading" fit highlight-current-row style="width: 100%">
			<el-table-column type="index" align="center" label='No.' min-width="50">
            </el-table-column>
			<el-table-column align="center" label='活动名' min-width="90">
                <template slot-scope="scope">
                {{scope.row.activityName}}
                </template>
            </el-table-column>
			<el-table-column align="center" label='订单号' min-width="170">
                <template slot-scope="scope">
                {{scope.row.orderCode}}
                </template>
            </el-table-column>
			<el-table-column align="center" label='订单日期' min-width="180">
                <template slot-scope="scope">
                {{scope.row.orderTime}}
                </template>
            </el-table-column>
			<el-table-column align="center" label='订单地址' min-width="480">
                <template slot-scope="scope">
                {{scope.row.deliveryAddress}}
                </template>
            </el-table-column>
			<el-table-column align="center" label='支付方式' min-width="80">
                <template slot-scope="scope">
                {{scope.row.paymentMethodName}}
                </template>
            </el-table-column>
			<el-table-column align="center" label='订单状态' min-width="80">
                <template slot-scope="scope">
                {{scope.row.orderStatusName}}
                </template>
            </el-table-column>
			<el-table-column align="center" label="操作" fixed="right" width="80">
				<template slot-scope="scope">
					<a @click="toDetail(scope.row)" style="color:#0000EE">查看</a>
				</template>
			</el-table-column>
		</el-table>

	</div>
</template>

<script>
import bar from '@/components/bar.vue'
import { orderList } from '../api/service'

export default {
	data() {
		return {
			list: null,
			listLoading: false,
			value1: ''
		};
	},
	methods: {
		clickbar() {
			this.$router.push({ path: '/vehicle' });
		},
		queryData() {
			this.fetchData()
		},
		toDetail (item) {
			const para = {
				id: item.id
			}
			this.$router.push({ path: 'orderDetail', query: para })
		},
		fetchData () {
			this.listLoading = true
			const params = {
				staffId: this.$store.getters.id,
				orderDate: this.value1,
				page_index: "1",
				page_size: "1000"
			}
			orderList(params).then(response => {
				if (response.data.success === true) {
					this.list = response.data.data.list
				} 
				this.listLoading = false
			}).catch(() => {
				this.listLoading = false
			})
		}
	},
	created() {
		this.fetchData()
	},
	components: {
		bar
	}
};
</script>

<style scoped>
li {
	list-style: none;
}
a {
	text-decoration: none;
}
.meconfirm-li li {
	display: inline-block;
	margin: 7px 67px 0 30px;
	font-size: 12px;
}
.meconfirm-li-li li {
	display: inline-block;
	margin: 7px 9px 0 30px;
	font-size: 12px;
}
.list-bar-ui {
	text-align: left;
}
.list-bar-ui li {
	list-style: none;
	color: white;
	font-weight: 200;
	margin-left: 20px;
	cursor: pointer;
	display: inline-block;
}
.top-bar {
	position: fixed;
	top: 0;
	bottom: auto;
	left: 0;
	right: auto;
	z-index: 80;
	width: 100%;
}
.top-color {
	height: 40px;
	background: #be0f34;
}
.top-color img {
	float: right;
	width: 209px;
	margin-top: 8px;
	padding-right: 300px;
}

.car-bar-box {
	cursor: pointer;
	width: 30px;
	height: 30px;
	background-image: url(../assets/img/cheo.png);
	background-size: 100%;
	background-repeat: no-repeat;
	position: absolute;
	top: 3px;
	right: 90px;
}
.vehicle-middle-box {
	width: 865px;
	bconfirm-bottom: 1px solid #e5e5e5;
	height: 100px;
	position: relative;
}
.vehicle-middle-box img {
	width: 80px;
	height: 80px;
	position: absolute;
	top: -23px;
	left: 54px;
}
.box {
	width: 886px;
	height: 30px;
	background-color: #e5e5e5;
	margin: 8px auto;
}
.meorder-span {
	position: absolute;
	top: 2px;
	left: 6px;
	width: 100px;
	font-size: 13px;
	text-align: left;
}
.meorder-span-two {
	position: absolute;
	top: 2px;
	left: 70px;
	width: 100px;
	font-size: 13px;
	text-align: left;
}
.meorder-span-five {
	position: absolute;
	top: 2px;
	left: 224px;
	width: 200px;
	font-size: 13px;
	text-align: left;
}
.meorder-div {
	position: absolute;
	top: 2px;
	left: 267px;
	width: 497px;
	font-size: 13px;
}
.meorder-div-two {
	position: absolute;
	top: 2px;
	width: 100px;
	left: 687px;
	font-size: 13px;
	text-align: left;
}
.meorder-div-three {
	position: absolute;
	top: 2px;
	width: 100px;
	left: 763px;
	font-size: 13px;
	text-align: left;
}
.meorder-div-frou {
	position: absolute;
	top: 2px;
	width: 100px;
	left: 834px;
	font-size: 13px;
	text-align: left;
}
</style>
